import {IProps} from "app/common/SimpleDialog/types";

/**
 * Purpose of these "Actions" is to mimic a more redux-style of event management, which
 * should make transitioning to redux a little easier when the time comes.
 */

const NS = 'StaffNameDialogActions';

export enum StaffNameDialogActionNames {
  SHOW_STAFF_NAME_DIALOG = 'SHOW_STAFF_NAME_DIALOG',
  HIDE_STAFF_NAME_DIALOG = 'HIDE_STAFF_NAME_DIALOG'
}

class StaffNameDialogActions {

  private $rootScope: any;

  setup($rootScope: any) {
    this.$rootScope = $rootScope;
  }

  hideDialog(): void {
    this.$rootScope.$broadcast(StaffNameDialogActionNames.HIDE_STAFF_NAME_DIALOG);
  }

  showDialog(props: IProps): void {
    this.$rootScope.$broadcast(StaffNameDialogActionNames.SHOW_STAFF_NAME_DIALOG, { payload: props as IProps });
  }

  handleShowDialog(callback: (props: IProps) => void) {
      this.$rootScope.$on(StaffNameDialogActionNames.SHOW_STAFF_NAME_DIALOG, (evt: any, {payload}: {payload: IProps}) => {
      callback(payload);
    });
  }

  handleHideDialog(callback: () => void) {
    this.$rootScope.$on(StaffNameDialogActionNames.HIDE_STAFF_NAME_DIALOG, (evt: any) => {
      callback();
    });
  }
}


const instance = new StaffNameDialogActions();
export default instance as StaffNameDialogActions;
